import * as React from 'react';
import { IUICfgAttributeElementSettings } from '@canvas-logic/clp-api-types';
import classNames from 'classnames';
import { IAttributeValueTextData } from '@canvas-logic/clp-domain';
import { observer } from 'mobx-react';

interface IProps {
  uiControl: IUICfgAttributeElementSettings;
  selectedTextData: IAttributeValueTextData | undefined;
}

export const AttributeDetails = observer(function AttributeDetails(props: IProps) {
  const { uiControl, selectedTextData } = props;
  const { showDetailsTitle, showDetailsDescription, showDetailsImage } = uiControl;

  return (
    <div className={classNames('cp-attribute__details')}>
      {showDetailsImage && selectedTextData?.image && (
        <img src={selectedTextData?.image.url} className={'cp-attribute__details__image'} />
      )}
      <div className={'cp-attribute__details__text'}>
        {showDetailsTitle && (
          <div className={'cp-attribute__details__title'}>
            {selectedTextData?.label?.toString() ?? selectedTextData?.value ?? ''}
          </div>
        )}
        {showDetailsDescription && (
          <div className={'cp-attribute__details__description'}>{selectedTextData?.description?.toString() ?? ''}</div>
        )}
      </div>
    </div>
  );
});
